// extracted by mini-css-extract-plugin
export default {"description":"CreateModerableSourceDialog_description__oADBi","closeBtn":"CreateModerableSourceDialog_closeBtn__0SP53"};